const config = {
    type: 'MULTIMEDIA',
    component: "Smu06",
    portrait: "/img/container/S-MU-06.jpg",
    body: {
        title: '',
        image: "https://placehold.co/300x200?text=Selecciona+o+arrastra+tu+imagen",
        content: ''
    },
}

export { config }